export const NOT_REQUESTED = "NOT_REQUESTED";
export const LOAD = "LOAD";
export const LOADED = "LOADED";
export const ERROR = "ERROR";
